/**
 * Marker store active Icon
 */
const MarkerStoreIconActive = ({ width = 42, height = 44 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_52912_304798)">
        <circle cx="20.9953" cy="21.9953" r="16.8" fill="white" />
        <path
          d="M21 4C11.0585 4 3 12.0585 3 22C3 31.9415 11.0585 40 21 40C30.9415 40 39 31.9415 39 22C39 12.0585 30.9415 4 21 4ZM9.21572 20.702C9.21572 20.1828 9.6362 19.766 10.1517 19.766H21.8044C22.3199 19.766 22.7404 20.1865 22.7404 20.702C22.7404 21.2176 22.3236 21.6344 21.8044 21.6344H10.1517C9.6362 21.6344 9.21572 21.2176 9.21572 20.702ZM26.7843 22.2633C26.7843 22.2633 24.042 31.042 23.4973 32.7642C22.7221 35.2102 20.0274 36.3181 17.7751 35.298C15.5009 34.2633 15.8921 32.1243 16.0896 31.4954L17.2596 27.7367C17.574 26.7166 17.6691 26.1389 17.2048 25.4296C16.6782 24.6837 15.7057 24.7276 15.3583 24.7276H14.0091C13.4936 24.7276 13.0768 24.3108 13.0768 23.7952C13.0768 23.2797 13.4936 22.8592 14.0091 22.8592H19.5155C20.7806 22.8592 21.3985 23.5612 20.8062 24.7276L17.8519 30.5704C17.2815 31.6856 17.2633 33.0786 18.5283 33.6124C20.0969 34.2742 21.4241 33.1335 21.8921 31.6271C22.1115 30.9214 25.0037 21.6929 25.0037 21.6929C25.2596 20.8921 25.4644 19.9488 24.9598 19.2322C24.4881 18.5631 23.4424 18.5338 23.0951 18.5338H12.6892C12.1737 18.5338 11.7569 18.117 11.7569 17.5978C11.7569 17.0786 12.1737 16.6618 12.6892 16.6618H23.1133C23.5119 16.6618 25.362 16.6252 26.4552 18.0292C27.2742 19.075 27.3583 20.468 26.7843 22.2596V22.2633ZM25.8848 15.7367C24.1517 15.7367 22.7441 14.3291 22.7441 12.596C22.7441 10.8629 24.1517 9.45521 25.8848 9.45521C27.6179 9.45521 29.0256 10.8592 29.0256 12.596C29.0256 14.3327 27.6179 15.7367 25.8848 15.7367Z"
          fill="#DA291C"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_52912_304798"
          x="0.428571"
          y="0.571429"
          width="41.1429"
          height="42.8571"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.857143" dy="1.71429" />
          <feGaussianBlur stdDeviation="0.857143" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_52912_304798"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.857143" dy="-1.71429" />
          <feGaussianBlur stdDeviation="0.857143" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_52912_304798"
            result="effect2_dropShadow_52912_304798"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_52912_304798"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default MarkerStoreIconActive
